/**
 * A forma em que a ficha do mapa deve se desenhar, dita pelo `PopupHost` ao
 * conteúdo. Só interessa às fichas que têm uma forma compacta — hoje, a do
 * sistema de nuvens (tracking/TrackingPopup): no celular ela é sempre
 * compacta; no desktop é completa, a não ser que a completa não caiba ao lado
 * do sistema sem cobri-lo (`popupArea.escolherForma`).
 */
import { createContext, useContext } from 'react';
import type { Forma } from './popupArea';

export interface FormaDaFicha {
  forma: Forma;
  /**
   * O usuário abriu (ou fechou) os detalhes de uma ficha compacta: aberta por
   * escolha dele, ela pode cobrir a área a evitar.
   */
  aoAbrirDetalhes: (abertos: boolean) => void;
}

export const ContextoDaFicha = createContext<FormaDaFicha>({ forma: 'completa', aoAbrirDetalhes: () => {} });

export function useFormaDaFicha(): FormaDaFicha {
  return useContext(ContextoDaFicha);
}
